import { ElectronicDocumentRequest } from '../requests/ElectronicDocumentRequest'

class ElectronicDocumentStore {
  pageIndex = 0
  pageSize = 10
  totalCount = 0
  queryParamsSignDocument = {
    page: 0,
    size: 10,
  }

  clearQueryParamsIncoming = () => {
    this.queryParamsSignDocument = {
      page: 0,
      size: 10,
    }
    this.totalCount = 0
  }

  electronicDocumentList = []
  selectedElectronicDocument = {}

  incrementPage = () => {
    this.queryParamsSignDocument.page += 1
  }

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  clearElectronicDocumentList = () => {
    this.electronicDocumentList.length = 0
  }
  clearSelectedElectronicDocument = () => {
    this.selectedElectronicDocument = {}
  }

  clearFilter = () => {
    this.pageIndex = 0
    this.pageSize = 10
    this.totalCount = 0
  }

  setQueryParamsSignDocument = payload => {
    this.queryParamsSignDocument = payload
  }

  getElectronicDocumentList = param => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.getElectronicDocumentList(param)
        .then(response => {
          this.totalCount = response.data.total_count
          this.electronicDocumentList = [
            ...this.electronicDocumentList,
            ...response.data.data,
          ]
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createElectronicDocument = dataSubmit => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.createElectronicDocument(dataSubmit)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getElectronicDocumentById = code => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.getElectronicDocumentById(code)
        .then(response => {
          this.selectedElectronicDocument = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  updateElectronicDocumentStatus = (data, code) => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.updateElectronicDocumentStatus(data, code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  updateFileElectronic = (file_id, action, code) => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.updateFileElectronic(file_id, action, code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  deleteElectronicDocument = code => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.deleteElectronicDocument(code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  addNewElectronicDocument = newDocument => {
    this.electronicDocumentList = [newDocument, ...this.electronicDocumentList]
  }

  // Comment electronic document

  commentElectronicDocumentList = []
  electronicDocumentCommentListSortByDatePost = 'ASC'

  clearCommentElectronicDocumentList = () => {
    this.commentElectronicDocumentList.length = 0
    this.electronicDocumentCommentListSortByDatePost = 'ASC'
  }

  getCommentElectronicDocumentList = code => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.getCommentElectronicDocumentList(code)
        .then(response => {
          this.commentElectronicDocumentList = response.data.reverse()
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createCommentElectronicDocument = (code, data) => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.createCommentElectronicDocument(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  deleteCommentElectronicDocument = (code, id_comment) => {
    return new Promise((resolve, reject) => {
      ElectronicDocumentRequest.deleteCommentElectronicDocument(
        code,
        id_comment
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new ElectronicDocumentStore()
